// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Utils
import { getDecimalNum } from "src/utils/number/numberHelper";
import { getCapitalizedText } from "src/utils/text/textHelper";

// Types
import { RAPDResultsType } from "src/services/exams/types";

type RAPDOverviewType = {
  rapdResults: RAPDResultsType;
};

const RAPDOverview = ({ rapdResults }: RAPDOverviewType) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "4px",
        border: "1px solid #000",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          background: "#000",
          color: "#FFF",
          padding: "8px",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {t("Exam Results")}
      </Typography>

      <Grid
        item
        xs={12}
        display="flex"
        flexWrap="wrap"
        padding="8px"
        rowGap="8px"
      >
        <Grid item xs={12} sm={6}>
          <Typography fontSize="14px">
            <span style={{ fontWeight: 600 }}>{t("RAPD Detected")}: </span>
            {rapdResults?.hasRAPD ? t("Yes") : t("No")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography fontSize="14px">
            <span style={{ fontWeight: 600 }}>{t("Severity")}: </span>
            {rapdResults?.severity
              ? t(getCapitalizedText(rapdResults?.severity))
              : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography fontSize="14px">
            <span style={{ fontWeight: 600 }}>{t("Affected Eye")}: </span>
            {rapdResults?.affectedEye
              ? t(getCapitalizedText(rapdResults?.affectedEye))
              : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography fontSize="14px">
            <span style={{ fontWeight: 600 }}>{t("ND Filter Value")}: </span>
            {!isNaN(rapdResults?.ndFilterValue)
              ? getDecimalNum(rapdResults?.ndFilterValue, 1)
              : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography fontSize="14px">
            <span style={{ fontWeight: 600 }}>{t("RAPD Value")}: </span>
            {!isNaN(rapdResults?.rawLogUnits)
              ? `${getDecimalNum(rapdResults?.rawLogUnits, 1)} ${t("log units")}`
              : "N/A"}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RAPDOverview;
